// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgWhiteboard24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M21 4H3C1.9 4 1 4.9 1 6V17C1 18.1 1.9 19 3 19H6.86L6.11 22.43C6.05 22.69 6.21 22.95 6.47 23.02L6.95 23.15C7.23 23.22 7.51 23.05 7.57 22.77L8.4 18.99H13.52C13.71 18.44 11.99 17.94 12.34 17.49H3.5C2.95 17.49 2.5 17.04 2.5 16.49V6.5C2.5 5.95 2.95 5.5 3.5 5.5H20.5C21.05 5.5 21.5 5.95 21.5 6.5V16.43C22.02 16.79 22.48 17.24 22.84 17.77C22.94 17.53 23 17.27 23 16.99V6C23 4.9 22.1 4 21 4Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3 4H21C22.1 4 23 4.9 23 6V17C23 18.1 22.1 19 21 19H17.14L17.89 22.43C17.95 22.69 17.79 22.95 17.53 23.02L17.05 23.15C16.77 23.22 16.49 23.05 16.43 22.77L15.6 18.99H12.48C12.29 18.44 12.01 17.94 11.66 17.49H20.5C21.05 17.49 21.5 17.04 21.5 16.49V6.5C21.5 5.95 21.05 5.5 20.5 5.5H3.5C2.95 5.5 2.5 5.95 2.5 6.5V16.43C1.98 16.79 1.52 17.24 1.16 17.77C1.06 17.53 1 17.27 1 16.99V6C1 4.9 1.9 4 3 4Z"
				/>
				<rect x={9.51196} y={2} width={1.5} height={3} rx={0.5} transform="rotate(9.82352 9.51196 2)" />
				<rect
					width={1.5}
					height={3}
					rx={0.5}
					transform="matrix(-0.985338 0.170614 0.170614 0.985338 14.478 2)"
				/>
			</Svg>
		);
	}
);
SvgWhiteboard24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgWhiteboard24;
